import React, { useState } from "react";
import { useStores } from "../../stores";
import { ICartItem, IProduct } from "../../stores/index.d";
import { AppConfig } from "../../AppConfig";
import defaultImgNa from "../../resources/images/image-na-alt.png";
import { ShowAlert, formatter } from "../../utilities/Functions";
import { toNumber } from "lodash";

const quotesOrderOnly = AppConfig?.QuotesOrderOnly;
interface IPopularProductItem {
  item: IProduct;
}

const PopularProductItem = ({ item }: IPopularProductItem) => {
  const { cartStore } = useStores();
  const { getCartItem, addItemToCart } = cartStore;
  const [itemQty, setItemQty] = useState(1);

  const handleAddToCart = (prod: any) => {
    let cartItem: ICartItem = getCartItem(prod.ProductId);
    if (cartItem) {
      cartItem.quantity += itemQty;
    } else {
      cartItem = prod;
      cartItem.quantity = itemQty;
    }

    addItemToCart(cartItem, true);
    setItemQty(1);
  };

  const handleSetItemQty = (qty: number) => {
    if (qty > 120) {
      ShowAlert.Warning("Maximum 120 quantity allowed.");
      return;
    }
    setItemQty(qty);
  };

  return (
    <div className="aside-single-products" key={item.ProductId}>
      <div className="products-image">
        <a href={"/prod/" + item.ProductId}>
          <img
            src={item?.ProductImagePath ?? defaultImgNa}
            alt="Product image"
          />
        </a>
      </div>
      <div className="products-content product-details-content">
        <h3>
          <a href={"/prod/" + item.ProductId}>{item.Name}</a>
        </h3>
        {!quotesOrderOnly ? (
          <div className="product-price">
            <span className="new-price">{formatter(item.SellPrice)}</span>
          </div>
        ) : null}

        <div className="product-add-to-cart d-flex">
          <div className="input-counter">
            <span
              className="minus-btn"
              onClick={() => {
                if (itemQty > 1) handleSetItemQty(itemQty - 1);
              }}
            >
              <i className="fas fa-minus"></i>
            </span>
            <input
              type="text"
              value={itemQty}
              onChange={(e) => handleSetItemQty(toNumber(e.target.value))}
            />
            <span
              className="plus-btn"
              onClick={() => {
                handleSetItemQty(itemQty + 1);
              }}
            >
              <i className="fas fa-plus"></i>
            </span>
          </div>

          <button
            type="button"
            className="btn btn-primary"
            onClick={(e) => {
              handleAddToCart(item);
            }}
          >
            <span id="lbl_prd_det_addcart">Add</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopularProductItem;
